import React from 'react';
import Button from 'src/ui/library/Button';
import Drawer from 'src/ui/library/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import Table from 'src/ui/library/Table';
import { TableBuildForm, TableGetChildren, TableDeleteRowInParser, TableUpdateRowInParser } from '../../elements/TableFactoryHelpers';

class HTComboTable extends React.Component {
  state = {
    rowIndex: null,
    showDelete: false,
    rowsSelected: [],
    popupFormChildren: null,
    popupFormElements: null,
  };

  tableFooter = () => {
    const { deleteRowsFn, cancelRowsFn } = this.props;
    const { rowsSelected, showDelete } = this.state;

    return (
      <section className="table-footer">
        {showDelete ? (
          <React.Fragment>
            <a onClick={deleteRowsFn.bind(null, rowsSelected)} key={'delete'}>
              Delete
            </a>
            <a onClick={cancelRowsFn()} key={'cancel'}>
              Cancel
            </a>
          </React.Fragment>
        ) : (
          <a onClick={() => this.handleOpen(true, 'ADD')}>+ Add Row</a>
        )}
      </section>
    );
  };

  handleClose = () => {
    const { popupFormElements } = this.state;

    // user has hit X without saving. remove the elements from the parser state
    TableDeleteRowInParser(popupFormElements, this.props.elementActions);

    this.setState({ showPopup: false, actionType: null, rowIndex: null });
  };

  handleOpen = (status, actionType = null, defaultValues = {}) => {
    const { tableHeadElements, elementActions } = this.props;
    const { tableElements } = TableGetChildren(tableHeadElements, elementActions);
    const { refreshShowLogic } = elementActions();

    const tableRowCount = tableElements.length / Object.keys(tableHeadElements).length;
    const { elements, children } = TableBuildForm(tableHeadElements, elementActions, tableRowCount, defaultValues);

    this.setState(
      {
        actionType,
        popupFormChildren: children,
        popupFormElements: elements,
        showPopup: true,
      },
      () => refreshShowLogic(),
    );
  };

  handleRemove = () => {
    const { popupFormElements, rowIndex } = this.state;
    const { tableHeadElements, elementActions } = this.props;
    const { tableElements } = TableGetChildren(tableHeadElements, elementActions);
    const { getParserState } = elementActions();

    const tableElementsIndex = tableElements.reduce((acc, next, index) => {
      acc[next.id] = index;
      return acc;
    }, {});

    const { elements, logicIndex } = getParserState();
    let elementsToRemove = [];

    popupFormElements.forEach(el => {
      const index = tableElementsIndex[el.id];
      const tableEl = tableElements[index];

      const positions = logicIndex[tableEl.logicId];

      positions.forEach(position => {
        let currentEl = elements[position];
        if (currentEl.rowIndex === rowIndex) {
          elementsToRemove.push({ rowIndex: currentEl.rowIndex, origRowIndex: currentEl.rowIndex, isRowSelected: true });
        }
      });
    });

    this.props.deleteRowsFn([elementsToRemove[0]]);

    this.setState({
      actionType: null,
      popupFormElements: null,
      popupFormChildren: null,
      showPopup: false,
    });
  };

  handleSave = () => {
    const { popupFormElements, actionType, rowIndex } = this.state;

    const { tableHeadElements, elementActions, addNewRowFn } = this.props;
    const { tableElements } = TableGetChildren(tableHeadElements, elementActions);

    const tableElementsIndex = tableElements.reduce((acc, next, index) => {
      acc[next.id] = index;
      return acc;
    }, {});

    TableDeleteRowInParser(popupFormElements, elementActions);

    if (actionType === 'EDIT') {
      const rowValues = popupFormElements.reduce((acc, next) => {
        const index = tableElementsIndex[next.id];
        const elValue = tableElements[index].props.value;
        acc[next.logicId] = elValue;
        return acc;
      }, {});

      TableUpdateRowInParser(rowValues, rowIndex, elementActions);
      this.props.refreshTableFn();

      const { callOnChange } = elementActions();
      callOnChange(this.props.id);
    } else {
      const rowValues = popupFormElements.map(el => {
        const index = tableElementsIndex[el.id];
        const elValue = tableElements[index].props.value;
        return elValue;
      });

      addNewRowFn(rowValues);
    }

    this.setState({
      actionType: null,
      popupFormElements: null,
      popupFormChildren: null,
      showPopup: false,
    });
  };

  onTableChange = (actionType, data) => {
    if (actionType === 'cellClick') {
      const { origRowIndex } = data.cellClicked;

      const { tableHeadElements, elementActions } = this.props;
      const { tableElements } = TableGetChildren(tableHeadElements, elementActions);

      const tableRowMap = tableElements.reduce((acc, next) => {
        if (next.rowIndex === origRowIndex) {
          acc[next.logicId] = next.props.value;
        }
        return acc;
      }, {});

      this.setState({ rowIndex: origRowIndex }, () => this.handleOpen(true, 'EDIT', tableRowMap));
    }

    if (actionType === 'rowSelected') {
      const { selectedRows } = data.model;

      this.setState({
        showDelete: selectedRows.length ? true : false,
        rowsSelected: selectedRows,
      });
    }
  };

  render() {
    const {
      label,
      setUpdateModelFn,
      addNewRowFn,
      elementActions,
      deleteRowsFn,
      cancelRowsFn,
      setTableModelFn,
      setCancelSelectedRows,
      setUpdateColumnFn,
      ...otherProps
    } = this.props;

    return (
      <div className={'horizontal-table'}>
        <span className={'table-label'}>{label}</span>
        <Drawer
          open={this.state.showPopup}
          anchor={'right'}
          styleType={'questionnaire'}
          isMobile={false}
          topFixed={true}
          onClose={this.handleClose}>
          <section className={'htcombo-popup-wrapper'}>
            <div className={'popup-title-wrapper'}>
              <h2 className={'title-text'}>{label}</h2>
              <a className={'title-action'} onClick={this.handleClose}>
                <CloseIcon />
              </a>
            </div>

            <div className={'popup-form'}>
              {this.state.popupFormChildren}
              <div className={'htcombo-actions'}>
                <div className={'button-wrapper'}>
                  <Button styleType={'secondary'} className={'action-button'} onClick={this.handleClose}>
                    Cancel
                  </Button>
                  <Button className={'action-button'} disabled={false} onClick={this.handleSave}>
                    Save
                  </Button>
                </div>
                {this.state.actionType === 'EDIT_SUPPRESS' && (
                  <div className={'remove-wrapper'}>
                    <a onClick={this.handleRemove} className={'ey-link'}>
                      Remove
                    </a>
                  </div>
                )}
              </div>
            </div>
          </section>
        </Drawer>
        <Table
          footer={this.tableFooter}
          updateModel={setUpdateModelFn}
          setTableModel={setTableModelFn}
          updateColumn={setUpdateColumnFn}
          onTableChange={this.onTableChange}
          cancelSelectedRows={setCancelSelectedRows}
          {...otherProps}
        />
      </div>
    );
  }
}

export default HTComboTable;
